import { createStore } from 'zustand/vanilla';

import { NotificationsStateType } from './notificationsState';

export const NotificationsStore = createStore<NotificationsStateType>()((set) => ({
  notifications: [],
  pushToaster: (toaster) => {
    const newToaster = { ...toaster, variant: 'toaster', timestamp: Date.now() } as const;

    set((state) => {
      let newNotifications = state.notifications;

      if (toaster.id?.length) {
        newNotifications = newNotifications.filter(({ id }) => {
          return id !== toaster.id;
        });
      }

      newNotifications = newNotifications.concat(newToaster);

      return {
        ...state,
        notifications: newNotifications,
      };
    });

    return newToaster;
  },
  pushAlert: (alert) => {
    const newAlert = { ...alert, variant: 'alert', timestamp: Date.now() } as const;

    set((state) => {
      let newNotifications = state.notifications;

      if (alert.id?.length) {
        newNotifications = newNotifications.filter(({ id }) => {
          return id !== alert.id;
        });
      }

      newNotifications = newNotifications.concat(newAlert);

      return {
        ...state,
        notifications: newNotifications,
      };
    });

    return newAlert;
  },
  clearExpired: () => {
    return set((state) => ({
      ...state,
      notifications: state.notifications.filter((notification) => notification.timestamp + notification.duration > Date.now()),
    }));
  },
  clearInfiniteNotifications: () => {
    return set((state) => ({
      ...state,
      notifications: state.notifications.filter((notification) => notification.duration !== Infinity),
    }));
  },
  removeNotification: (toRemove) => {
    return set((state) => ({
      ...state,
      notifications: state.notifications.filter(
        (notif) =>
          notif !== toRemove && notif.id !== toRemove.id && !(notif.title === toRemove.title && notif.timestamp === toRemove.timestamp),
      ),
    }));
  },
}));
